import React, { FC } from 'react';
import { useSelector, RootState } from 'src/store';
import { changeEnterHTML } from 'src/utils/changeEnter';
import { getFontURL } from 'src/utils/getFontUrl';
import { trackingList } from 'src/utils/valueHTML';

const TEXT_2_JUSTIFY = {
  left: 'start',
  center: 'center',
  right: 'end'
};

const FullDualImage: FC = () => {
  const bg = useSelector((state: RootState) => state.imageUpload.bg);
  const bgImage = useSelector((state: RootState) => state.imageUpload.bgImage);
  const bgColor = useSelector((state: RootState) => state.imageUpload.bgColor);
  const deeplink = useSelector(
    (state: RootState) => state.imageUpload.deeplink
  );
  const radius = useSelector((state: RootState) => state.imageUpload.radius);

  const text = useSelector((state: RootState) => state.editText.text);
  const fontSize = useSelector((state: RootState) => state.editText.fontSize);
  const fontWeight = useSelector(
    (state: RootState) => state.editText.fontWeight
  );
  const color = useSelector((state: RootState) => state.editText.color);
  const fontFamily = useSelector(
    (state: RootState) => state.editText.fontFamily
  );
  const textAlign = useSelector((state: RootState) => state.editText.textAlign);

  const btnText = useSelector((state: RootState) => state.buttons.btnText);
  const btnFontSize = useSelector(
    (state: RootState) => state.buttons.btnFontSize
  );
  const btnFontWeight = useSelector(
    (state: RootState) => state.buttons.btnFontWeight
  );
  const btnColor = useSelector((state: RootState) => state.buttons.btnColor);
  const btnBgColorR = useSelector(
    (state: RootState) => state.buttons.btnBgColorR
  );
  const btnBgColorG = useSelector(
    (state: RootState) => state.buttons.btnBgColorG
  );
  const btnBgColorB = useSelector(
    (state: RootState) => state.buttons.btnBgColorB
  );
  const btnBgColorA = useSelector(
    (state: RootState) => state.buttons.btnBgColorA
  );
  const btnFontFamily = useSelector(
    (state: RootState) => state.buttons.btnFontFamily
  );

  const tracking = useSelector((state: RootState) => state.trackings.tracking);
  const button1 = useSelector((state: RootState) => state.trackings.button1);
  const button2 = useSelector((state: RootState) => state.trackings.button2);

  const titleFontURL = getFontURL(fontFamily?.title);
  const subTitleFontURL = getFontURL(fontFamily?.sub_title);
  const multiTitleURL = getFontURL(fontFamily.multi_title);
  const multiSubTitleURL = getFontURL(fontFamily.multi_sub_title);
  const btnURL = getFontURL(btnFontFamily?.button);
  const multiBtnURL = getFontURL(btnFontFamily?.multi_button);
  // const titleFontURL = `https://workspace.inappmessage.com/${currentUser}/font/${fontFamily?.title}`;
  // const subTitleFontURL = `https://workspace.inappmessage.com/${currentUser}/font/${fontFamily?.sub_title}`;
  // const multiTitleURL = `https://workspace.inappmessage.com/${currentUser}/font/${fontFamily.multi_title}`;
  // const multiSubTitleURL = `https://workspace.inappmessage.com/${currentUser}/font/${fontFamily.multi_sub_title}`;
  // const btnURL = `https://workspace.inappmessage.com/${currentUser}/font/${btnFontFamily?.button}`;
  // const multiBtnURL = `https://workspace.inappmessage.com/${currentUser}/font/${btnFontFamily?.multi_button}`;

  const style = `
  @font-face {
    font-family: 'title';
    src: url(${titleFontURL});
  }
  @font-face {
    font-family: 'subTitle';
    src: url(${subTitleFontURL});
  }
  @font-face {
    font-family: 'multiTitle';
    src: url(${multiTitleURL});
  }
  @font-face {
    font-family: 'multiSubTitle';
    src: url(${multiSubTitleURL});
  }
  @font-face {
    font-family: 'btn';
    src: url(${btnURL});
  }
  @font-face {
    font-family: 'multiBtn';
    src: url(${multiBtnURL});
  }
    /* reset */
    * {
      box-sizing: border-box;
      margin: 0;
      padding: 0;
      list-style: none;
      text-decoration: none;
      
    }
    html,
    body {
      height: 100%;
      overflow: hidden;
    }
    main {
      height: 100%;
      position: relative;
    }
    a {
      color: #000000;
      cursor: pointer;
    }
    button {
      background: none;
      border: none;
    }

    /* custom */
    .root {
      width: 100%;
      height: 100%;
      padding: 0 10%;

      overflow: hidden;
      position: relative;
      ${
        bg === 'image'
          ? `background-image: url(${bgImage?.background});`
          : `background: ${bgColor?.background};`
      };

      background-repeat: no-repeat;
      background-size: cover;
      background-position: center;
      position: relative;
    }

    .center_wrapper {
      width: 100%;
      padding-top: 10%;
      padding: 0 10%;
      display: flex;
      flex-direction: column;
      gap: 0.5rem;

      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
    .contents_wrapper {
      display: flex;
      flex-direction: column;
      gap: 0.5rem;
    }
    .center_wrapper .title {
      height: 3.5rem;
      display: flex;
      align-items: center;
      text-align: ${textAlign?.title};
      justify-content: ${TEXT_2_JUSTIFY[textAlign?.title]};
    }
    .title_inner {
      text-overflow: ellipsis;
      overflow: hidden;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;

      color: ${color?.title};
      font-size: ${fontSize?.title}rem;
      font-weight: ${fontWeight?.title};
      font-family: ${
        ['Roboto', 'Inter', 'Montserrat', 'Poppins', 'Pretendard'].includes(
          fontFamily?.title
        )
          ? fontFamily.title
          : 'title'
      };
    }
    .center_wrapper .sub_title {
      width: 100%;
      height: 2.5rem;

      display: flex;
      align-items: center;
    }
    .center_wrapper .sub_title_inner {
      width: 100%;

      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;

      text-align: ${textAlign?.sub_title};
      color: ${color?.sub_title};
      font-size: ${fontSize?.sub_title}rem;
      font-weight: ${fontWeight?.sub_title};
      font-family: ${
        ['Roboto', 'Inter', 'Montserrat', 'Poppins', 'Pretendard'].includes(
          fontFamily?.sub_title
        )
          ? fontFamily.sub_title
          : 'subTitle'
      };
      overflow: hidden;
    }

    .contents_wrapper .image_box {
      width: 100%;
      position: relative;
    }
    .contents_wrapper .image {
      width: 100%;
      aspect-ratio: 9/5;
      border-radius: ${radius?.multi_image}px;
      object-fit: cover;
    }
    .contents_wrapper .multi_title {
      width: 100%;
      height: 2rem;

      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;

      display: flex;
      align-items: center;
      justify-content: ${TEXT_2_JUSTIFY[textAlign?.multi_title]};

      color: ${color?.multi_title};
      font-size: ${fontSize?.multi_title}rem;
      font-weight: ${fontWeight?.multi_title};
      font-family: ${
        ['Roboto', 'Inter', 'Montserrat', 'Poppins', 'Pretendard'].includes(
          fontFamily?.multi_title
        )
          ? fontFamily?.multi_title
          : 'multiTitle'
      };
    }
    .contents_wrapper .multi_sub_title {
      height: 1.5rem;

      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;

      display: flex;
      align-items: center;
      justify-content: ${TEXT_2_JUSTIFY[textAlign?.multi_sub_title]};

      color: ${color?.multi_sub_title};
      font-size: ${fontSize?.multi_sub_title}rem;
      font-weight: ${fontWeight?.multi_sub_title};
      font-family: ${
        ['Roboto', 'Inter', 'Montserrat', 'Poppins', 'Pretendard'].includes(
          fontFamily?.multi_sub_title
        )
          ? fontFamily?.multi_sub_title
          : 'multiSubTitle'
      };
    }

    .contents_wrapper .multi_button {
      position: absolute;
      right: 1rem;
      bottom: 1rem;
    }
    .contents_wrapper button {
      padding: 0.25rem 0.75rem;
      border: 0;

      color: ${btnColor?.multi_button};
      font-size: ${btnFontSize?.multi_button}rem;
      font-weight: ${btnFontWeight?.multi_button};
      font-family: ${
        ['Roboto', 'Inter', 'Montserrat', 'Poppins', 'Pretendard'].includes(
          btnFontFamily?.multi_button
        )
          ? btnFontFamily?.multi_button
          : 'multiBtn'
      };

      border-radius: ${radius?.multi_button}px;
      background-color:rgba(${btnBgColorR?.multi_button},${
    btnBgColorG?.multi_button
  }, ${btnBgColorB?.multi_button}, ${btnBgColorA?.multi_button});
    }

    .bottom_wrapper {
      width: 100%;
      margin-top: 1rem;
    }
    .bottom_wrapper button {
      width: 100%;
      height: 3rem;
      
      cursor: pointer;
      outline: 0;
      border: 0;

      color: ${btnColor?.button};
      font-size: ${btnFontSize?.button}rem;
      font-weight: ${btnFontWeight?.button};
      font-family: ${
        ['Roboto', 'Inter', 'Montserrat', 'Poppins', 'Pretendard'].includes(
          btnFontFamily?.button
        )
          ? btnFontFamily?.button
          : 'btn'
      };
      border-radius: ${radius?.button}px;
      background-color:rgba(${btnBgColorR?.button},${btnBgColorG?.button}, ${
    btnBgColorB?.button
  }, ${btnBgColorA?.button});
    }

    @media screen and (max-height: 667px) {
      .center_wrapper {
        gap: 0rem;
      }
      .center_wrapper .title {
        height: 2.5rem;
      }
      .title_inner {
        font-size: ${fontSize?.title - 0.375}rem;
      }

      .center_wrapper .sub_title {
        height: 2rem;
        margin-bottom: 0.5rem;
      }

      .contents_wrapper .multi_title {
        height: 1.5rem;
      }
      .contents_wrapper .multi_sub_title {
        height: 1rem;
        margin-bottom: 0.5rem;
      }

      .bottom_wrapper {
        margin-top: 0rem;
      }
    }

    @media screen and (min-width: 608px) and (max-width: 1024px) {
      .root {
        padding: 0 25%;
      }
      .close_btn {
        right: 25%;
        top: 4rem;
      }

      .center_wrapper {
        padding: 0 25%;
      }
      .center_wrapper .title {
        height: 4rem;
        font-size: ${fontSize?.title + 0.25}rem;
      }
      .center_wrapper .sub_title {
        height: 3.5rem;
        font-size: ${fontSize?.sub_title + 0.25}rem;
      }
      .center_wrapper .sub_inner_title {
        height: 2.6rem;
      }
      .contents_wrapper .image_box,
      .contents_wrapper .image {
        height: 14rem;
      }
      .contents_wrapper .multi_title {
        height: 3rem;
        font-size: ${fontSize?.multi_title + 0.5}rem;
      }

      .bottom_wrapper button {
        width: 100%;
        height: 4rem;
      }
    }
  `;

  const html = `
    <div class="root">
      <div class="center_wrapper">
        <div class="title">
          <div class="title_inner">${changeEnterHTML(text?.title)}</div>
        </div>
        <div class="sub_title">
          <div class="sub_title_inner">
            ${changeEnterHTML(text?.sub_title)}
          </div>
        </div>${text?.multi_title
          ?.map(
            (data: any, idx: number) => `
            <div class="contents_wrapper">
              <div class="image_box image_box_${idx}">
                <img class="image image_${idx}" src="${
              bgImage?.multi_image?.[idx]
            }" />
                <button class="multi_button multi_button_${idx}">
                  ${btnText?.multi_button?.[idx]}
                </button>
              </div>
              <div>
                <div class="multi_title">${changeEnterHTML(
                  text?.multi_title?.[idx]
                )}</div>
                <div class="multi_sub_title">
                  ${changeEnterHTML(text?.multi_sub_title?.[idx])}
                </div>
              </div>
            </div>
          `
          )
          .join('')}
        <div class="bottom_wrapper">
          <button>${btnText?.button}</button>
        </div>
      </div>
    </div>
  `;

  let deeplink_list = '[';
  for (let i = 0; i < deeplink?.multi_image?.length; i++) {
    deeplink_list += `'${deeplink?.multi_image?.[i]}'`;
    if (i !== deeplink?.multi_image?.length - 1) deeplink_list += ',';
  }
  deeplink_list += ']';

  let tracking_list = '[';
  for (let i = 0; i < tracking?.multi_image?.length; i++) {
    tracking_list += `['${tracking?.multi_image?.[i]}', '${tracking?.multi_button?.[i]}', '${tracking?.button?.[i]}'],`;
  }
  tracking_list += ']';

  const tracking_button_list = trackingList(
    'FULL DUAL IMAGE',
    button1,
    button2
  );

  const js = `
  document.addEventListener("DOMContentLoaded", function(){
    $('.image_box_0').click(function() {
      appboyBridge.logClick('image 1');
    });
    $('.image_box_1').click(function() {
      appboyBridge.logClick('image 2');
    });

    let deeplink = ${deeplink_list};
    let tracking = ${tracking_list};
    let button1 = ${tracking_button_list[0]};
    let button2 = ${tracking_button_list[1]};
    $('.image_0').click(function() {
      appboyBridge.logClick(tracking[0][0]);
      try {
        if (button1[0].indexOf(0) !== -1) {
          appboyBridge.logClick('0');
        }
        if (button2[0].indexOf(0) !== -1) {
          appboyBridge.logClick('1');
        }
      } catch (err) {}
      window.location = deeplink[0];
    });
    $('.multi_button_0').click(function(event) {
      event.stopPropagation();
      appboyBridge.logClick(tracking[0][1]);
      try {
        if (button1[1].indexOf(0) !== -1) {
          appboyBridge.logClick('0');
        }
        if (button2[1].indexOf(0) !== -1) {
          appboyBridge.logClick('1');
        }
      } catch (err) {}
      window.location = deeplink[0];
    });

    $('.image_1').click(function() {
      appboyBridge.logClick(tracking[1][0]);
      try {
        if (button1[0].indexOf(1) !== -1) {
          appboyBridge.logClick('0');
        }
        if (button2[0].indexOf(1) !== -1) {
          appboyBridge.logClick('1');
        }
      } catch (err) {}
      window.location = deeplink[1];
    });
    $('.multi_button_1').click(function() {
      event.stopPropagation();
      appboyBridge.logClick(tracking[1][1]);
      try {
        if (button1[1].indexOf(1) !== -1) {
          appboyBridge.logClick('0');
        }
        if (button2[1].indexOf(1) !== -1) {
          appboyBridge.logClick('1');
        }
      } catch (err) {}
      window.location = deeplink[1];
    });

    $('.bottom_wrapper').click(function() {
      appboyBridge.logClick(tracking[0][2]);
      try {
        if (button1[2].indexOf(0) !== -1) {
          appboyBridge.logClick('0');
        }
        if (button2[2].indexOf(0) !== -1) {
          appboyBridge.logClick('1');
        }
      } catch (err) {}
      appboyBridge.closeMessage();
    });
  });
  `;

  return (
    <>
      <head>
        <meta charSet="UTF-8" />
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"
        />
        {/* google font */}
        <link rel="preconnect" href="https://fonts.googleapis.com" />
        <link rel="preconnect" href="https://fonts.gstatic.com" />
        <link
          href="https://fonts.googleapis.com/css2?family=Roboto:wght@300;400;500;600;700&display=swap"
          rel="stylesheet"
        />
        <link
          href="https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&display=swap"
          rel="stylesheet"
        />
        <link
          href="https://fonts.googleapis.com/css2?family=Montserrat:wght@300;400;500;600;700&display=swap"
          rel="stylesheet"
        />
        <link
          href="https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700&display=swap"
          rel="stylesheet"
        />
        <link
          href="https://fonts.googleapis.com/css2?family=Archivo:wght@300;400;500;600;700&display=swap"
          rel="stylesheet"
        />
        <link
          rel="stylesheet"
          as="style"
          href="https://cdn.jsdelivr.net/gh/orioncactus/pretendard@v1.3.9/dist/web/static/pretendard.min.css"
        />
        <link
          rel="stylesheet"
          type="text/css"
          href="https://cdn.jsdelivr.net/npm/normalize.css@8.0.1/normalize.css"
        />
        <link
          rel="stylesheet"
          type="text/css"
          href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.9.0/slick.css"
        />
        <link
          rel="stylesheet"
          type="text/css"
          href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.9.0/slick-theme.css"
        />

        {/* jquery */}
        <script id="test" src="https://code.jquery.com/jquery-3.6.0.min.js" />
        <script src="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick.min.js" />
        <style dangerouslySetInnerHTML={{ __html: style }} />
      </head>
      <body dangerouslySetInnerHTML={{ __html: html }} />
      <script dangerouslySetInnerHTML={{ __html: js }} />
    </>
  );
};

export default FullDualImage;
